import React, { useState, useEffect } from 'react';
import { TrendingUp, Package, AlertTriangle, DollarSign } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { productAPI, invoiceAPI } from '../utils/api';
import '../styles/Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    todaySales: 0,
    monthSales: 0,
    monthGst: 0,
    totalProducts: 0,
    lowStockItems: 0,
  });
  const [loading, setLoading] = useState(true);
  const [topProducts, setTopProducts] = useState([]);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const [productsRes, invoicesRes] = await Promise.all([
        productAPI.getAll(),
        invoiceAPI.getAll(),
      ]);

      setStats({
        todaySales: 0,
        monthSales: 0,
        monthGst: 0,
        totalProducts: productsRes.data.length,
        lowStockItems: productsRes.data.filter(p => p.stockQuantity < 10).length,
      });

      // Calculate top selling products
      if (invoicesRes.data && invoicesRes.data.length > 0) {
        const productSales = {};
        invoicesRes.data.forEach((invoice) => {
          // Product calculation would need invoice items
        });
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  const openNewInvoice = () => {
    navigate('/invoices');
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('openInvoiceTypeModal'));
    }, 100);
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading Dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Dashboard</h1>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">
            <DollarSign size={24} />
          </div>
          <div className="stat-content">
            <h3>Today's Sales</h3>
            <p className="stat-value">₹{stats.todaySales.toFixed(2)}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <TrendingUp size={24} />
          </div>
          <div className="stat-content">
            <h3>Monthly Sales</h3>
            <p className="stat-value">₹{stats.monthSales.toFixed(2)}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <Package size={24} />
          </div>
          <div className="stat-content">
            <h3>Total Products</h3>
            <p className="stat-value">{stats.totalProducts}</p>
          </div>
        </div>

        <div className="stat-card warning">
          <div className="stat-icon">
            <AlertTriangle size={24} />
          </div>
          <div className="stat-content">
            <h3>Low Stock Items</h3>
            <p className="stat-value">{stats.lowStockItems}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">
            <DollarSign size={24} />
          </div>
          <div className="stat-content">
            <h3>Monthly GST Collected</h3>
            <p className="stat-value">₹{stats.monthGst.toFixed(2)}</p>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>Quick Actions</h2>
        </div>
        <div className="quick-actions">
          <button className="action-btn" onClick={openNewInvoice}>
            <span>➕</span>
            <span>New Invoice</span>
          </button>
          <button className="action-btn" onClick={() => navigate('/customers')}>
            <span>👥</span>
            <span>Add Customer</span>
          </button>
          <button className="action-btn" onClick={() => navigate('/products')}>
            <span>📦</span>
            <span>Add Product</span>
          </button>
          <button className="action-btn" onClick={() => navigate('/reports')}>
            <span>📊</span>
            <span>View Reports</span>
          </button>
        </div>
      </div>

      <div className="info-section">
        <div className="card">
          <div className="card-header">
            <h2>System Information</h2>
          </div>
          <div className="info-content">
            <p>✓ All data is stored locally - 100% Offline</p>
            <p>✓ Auto-save enabled for all changes</p>
            <p>✓ Database: SQLite</p>
            <p>✓ Last sync: Just now</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
